//商品発注書 更新画面
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useMediaQuery,
  Tooltip
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getEndOfDay } from '../apicalls/createCustomer';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import { getUnitMasterList } from '../apicalls/unitMaster';
import { getVendorList } from '../apicalls/getVendorDetails';
import {
  getDeliverySites,
  getMerchandiseOrderDetails,
  updateMerchandiseOrder,
  updateMerchandiseOrderInvoiceTotal
} from '../apicalls/merchandiseOrder';
import { savePdf } from '../apicalls/savePdf';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { DatePickerInput } from '../components/atoms';
import LoadingComponent from '../components/LoadingComponent';
import NumberInput from '../components/NumberInput';
import { productPurchasePdf } from '../generatePdf/productPurchasePdf';
import { btnColor, isLoggedIn, mainBlueColor, userRole } from '../GlobalState';
import { parsePrice } from '../utils';
import './List.css';
import {
  MERCHANDISE_ORDERS_ITEM_MAX,
  DOCUMENT_TYPE,
  EMPLOYEE_TYPE,
  EMPLOYEE_STATUS
} from '../const/Const';
import { formatDatetime, isValidNumber } from '../utils/common';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';
import { VendorSearchDialog } from '../components/VendorSearchDialog';
import HelpIcon from '@material-ui/icons/Help';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import { calcTotalFromQuantityAndUnitPrice } from '../utils/calcRules';
import { StaffData } from '../types/staffData';
import { getStaffSelectOptions } from '../utils/getStaffSelectOptions';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

export const EditProductPurchase: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission] = useRecoilState(userRole);
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [userData, setUserData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [deliverySitesData, setDeliverySitesData] = useState([]);
  const [mUnitsData, setMUnitsData] = useState([]);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const params: any = useParams();

  const [userId, setUserId] = useState<number>(0);
  const [constructId, setConstructId] = useState<number>(0);
  const [honorificTitle, setHonorificTitle] = useState('御中');
  const [deliverySiteId, setDeliverySiteId] = useState<number>(0);
  const [orderDate, setOrderDate] = useState('');
  const [orderStatus, setOrderStatus] = useState<number>(1);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [sampleUserId1, setSampleUserId1] = useState<number>(0);
  const [sampleUserId2, setSampleUserId2] = useState<number>(0);
  const [remarks, setRemarks] = useState('');
  const [memo, setMemo] = useState('');
  const [billingNote, setBillingNote] = useState('');

  const [selectedOrderDate, setSelectedOrderDate] = useState<Date | null>(null);
  const [selectedDeliveryDate, setSelectedDeliveryDate] =
    useState<Date | null>(null);

  const [productNameList, setProductNameList] = useState<any>([]);
  const [specificationList, setSpecificationList] = useState<any>([]);
  const [unitPriceList, setUnitPriceList] = useState<any>([]);
  const [quantityList, setQuantityList] = useState<any>([]);
  const [amountList, setAmountList] = useState<any>([]);
  const [hiddenList, setHiddenList] = useState<boolean[]>([]);
  const [unitList, setUnitList] = useState<any>([]);
  const [deliveryLocationList, setDeliveryLocationList] = useState<any>([]);
  const [deliveryDateList, setDeliveryDateList] = useState<any>([]);

  const [rowCount, setRowCount] = useState<any>([]);
  const [itemIds, setItemIds] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [showLinearProgress, setShowLinearProgress] = useState(false);
  const [productPurchaseDetailData, setProductPurchaseDetailData] =
    useState<any>({});
  const [initialCreaterData, setInitialCreaterData] =
    useState<StaffData | null>(null);

  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [openSelectModal, setopenSelectModal] = useState(false);
  const [vendorDataSearch, setVendorDataSearch] = useState([]);
  const [vendorName, setVendorName] = useState<number>(0);

  const [selectedPaymentDate, setSelectedPaymentDate] =
    useState<Date | null>(null);
  const [paymentDate, setPaymentDate] = useState('');

  const [addRowButton, setAddRowButton] = useState<boolean>(true);

  // 請求金額用State
  const [invoiceBillingTotal, setInvoiceBillingTotal] =
    useState<number | undefined>(undefined);
  const [endOfDay, setEndOfDay] = useState([]);
  const [documentNumber, setDocumentNumber] = useState('');
  const [constructionName, setConstructionName] = useState<string>('');

  /**
   * 発注日
   */
  const handleOrderDateChange = (date: Date | null) => {
    setSelectedOrderDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setOrderDate(finaldate);
  };

  /**
   * 納品日
   */
  const handleDeliveryDateChange = (date: Date | null) => {
    setSelectedDeliveryDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setDeliveryDate(finaldate);
    calculationPaymentDate(vendorName, date);
  };

  const handleDeliveryDateChangeList = (date: Date | null, k: number) => {
    let newNameArr1: any = [...deliveryDateList];
    var finaldate: any = date?.toISOString().split('T')[0];
    newNameArr1[k] = finaldate;
    setDeliveryDateList(newNameArr1);
  };

  /**
   * 支払予定日
   */
  const handleSelectedPaymentDate = (date: Date | null) => {
    setSelectedPaymentDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setPaymentDate(finaldate);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },
      table1: {},
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputQuantityBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1,
        textAlign: 'right'
      },
      subContainer: {
        marginLeft: 15,
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        maxHeight: 80,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        textAlign: 'right',
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      fixedTextContainer: {
        fontSize: 14,
        marginLeft: 15
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      progress: {
        backgroundColor: '#c1c1c1',
        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: mainColor
        }
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();

  // const handleClickOpenAlert = () => {
  //   setOpenAlert(true);
  // };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setUserData(data.data);
            }
          }
        }
      }
    );
  }, [changeLoggedInData]);

  const getListOfDeliverySites = useCallback(() => {
    getDeliverySites().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setDeliverySitesData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfVendors = useCallback(() => {
    getVendorList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setVendorData(data.data);
            setVendorDataSearch(data.data);
            getAllEndOfDay();
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllEndOfDay = () => {
    getEndOfDay().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEndOfDay(data.data);
          }
        }
      }
    });
  };

  const calculationPaymentDate = (vendorId: number, date: any) => {
    if (vendorId === 0) {
      return;
    }
    if (date) {
      let vendor: any = vendorData.filter((item: any) => item.id === vendorId);
      if (vendor[0].end_day === '' || vendor[0].payment_site === '') {
        return;
      }
      let copySelectedDeliveryDate: any = date;
      // 締日の取得
      let selectedEndDate: any = endOfDay.filter(
        (item: any) => item.id === vendor[0].end_day
      );
      // 支払い月の取得
      let vendorPaymentSiteMonthList: any = [
        { name: '当月', month: 0 },
        { name: '翌月', month: 1 },
        { name: '翌々月', month: 2 },
        { name: '翌々々月', month: 3 }
      ];
      let vendorPaymentSiteMonth: any = vendorPaymentSiteMonthList.filter(
        (item: any) => {
          if (item.name.length < 3) {
            return item.name === vendor[0].payment_site.slice(0, 2);
          } else if (item.name.length === 3) {
            return item.name === vendor[0].payment_site.slice(0, 3);
          } else {
            return item.name === vendor[0].payment_site.slice(0, 4);
          }
        }
      );
      // 支払日の取得
      let vendorPaymentSiteDay: any = '';
      if (vendor[0].payment_site.slice(-1) !== '末') {
        vendorPaymentSiteDay =
          vendor[0].payment_site.slice(-2) === '-5'
            ? 5
            : vendor[0].payment_site.slice(-2);
      } else {
        let a = new Date(
          copySelectedDeliveryDate.getFullYear(),
          copySelectedDeliveryDate.getMonth() +
            1 +
            vendorPaymentSiteMonth[0].month,
          0
        );
        vendorPaymentSiteDay = a.getDate();
      }
      // 納品日が締日の前後どちらかを判定する為のデータ
      const copyDeliveryDate: number = new Date(
        copySelectedDeliveryDate.getFullYear(),
        copySelectedDeliveryDate.getMonth(),
        copySelectedDeliveryDate.getDate()
      ).getTime();
      const maxEndDate: number = new Date(
        copySelectedDeliveryDate.getFullYear(),
        copySelectedDeliveryDate.getMonth() +
          (selectedEndDate[0].name === '末日' ? +1 : 0),
        selectedEndDate[0].name === '末日' ? 0 : selectedEndDate[0].name
      ).getTime();

      // 支払日が当月のデータを除外した処理
      if (
        vendor[0].payment_site.slice(-1) !== '末' &&
        vendorPaymentSiteMonth[0].name !== '当月'
      ) {
        // 支払日が末でない
        // 納品日が締日より前か後かの処理
        if (copyDeliveryDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() +
              vendorPaymentSiteMonth[0].month,
            vendorPaymentSiteDay,
            12
          );
          handleSelectedPaymentDate(setDate);
        } else {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() +
              vendorPaymentSiteMonth[0].month +
              1,
            vendorPaymentSiteDay,
            12
          );
          handleSelectedPaymentDate(setDate);
        }
      } else if (
        vendor[0].payment_site.slice(-1) === '末' &&
        vendorPaymentSiteMonth[0].name !== '当月'
      ) {
        // 支払日が末だった場合
        if (copyDeliveryDate <= maxEndDate) {
          let endOfTheMonth = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() +
              vendorPaymentSiteMonth[0].month +
              1,
            0,
            12
          );
          handleSelectedPaymentDate(endOfTheMonth);
        } else {
          let endOfTheMonth = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() +
              vendorPaymentSiteMonth[0].month +
              2,
            0,
            12
          );
          handleSelectedPaymentDate(endOfTheMonth);
        }
        //
        // 以下、支払い月が「当月」の処理。締日より支払日が前にあった場合に、誤った日付が入るのを防ぐ
        //
      } else if (
        vendor[0].payment_site.slice(-1) !== '末' &&
        selectedEndDate[0].name <= vendorPaymentSiteDay
      ) {
        if (copyDeliveryDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth(),
            vendorPaymentSiteDay,
            12
          );
          handleSelectedPaymentDate(setDate);
        } else {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() + 1,
            vendorPaymentSiteDay,
            12
          );
          handleSelectedPaymentDate(setDate);
        }
      } else if (
        vendor[0].payment_site.slice(-1) !== '末' &&
        vendorPaymentSiteDay < selectedEndDate[0].name
      ) {
        if (copyDeliveryDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() + 1,
            vendorPaymentSiteDay,
            12
          );
          handleSelectedPaymentDate(setDate);
        } else {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() + 2,
            vendorPaymentSiteDay,
            12
          );
          handleSelectedPaymentDate(setDate);
        }
      } else if (vendor[0].payment_site.slice(-1) === '末') {
        if (copyDeliveryDate <= maxEndDate) {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() + 1,
            0,
            12
          );
          handleSelectedPaymentDate(setDate);
        } else {
          let setDate = new Date(
            copySelectedDeliveryDate.getFullYear(),
            copySelectedDeliveryDate.getMonth() + 2,
            0,
            12
          );
          handleSelectedPaymentDate(setDate);
        }
      }
    }
  };

  const getListOfMUnits = useCallback(() => {
    getUnitMasterList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setMUnitsData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);
  //選択中の商品購入番号
  const { id: product_id }: any = useParams();
  const getTheDetailsOfMerchandiseOrders = (
    newProductPurchaseId: any = null,
    goPreview = false
  ) => {
    getMerchandiseOrderDetails(
      newProductPurchaseId ? newProductPurchaseId : product_id
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            if (newProductPurchaseId) {
              //code for checking whether the data is updated or not, if any data is updated new pdf will be generated and upload
              let isDataUpdated: boolean = false;

              if (productPurchaseDetailData['items']) {
                if (
                  productPurchaseDetailData['items'].length !==
                  data.data['items'].length
                ) {
                  isDataUpdated = true;
                } else {
                  for (
                    let i = 0;
                    i < productPurchaseDetailData['items'].length;
                    i++
                  ) {
                    if (
                      productPurchaseDetailData['items'][i].id !==
                      data.data['items'][i].id
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].name !==
                      data.data['items'][i].name
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].spec !==
                      data.data['items'][i].spec
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].unit_price !==
                      data.data['items'][i].unit_price
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].quantity !==
                      data.data['items'][i].quantity
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].price !==
                      data.data['items'][i].price
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].delivery_date !==
                      data.data['items'][i].delivery_date
                    ) {
                      isDataUpdated = true;
                      break;
                    }

                    if (
                      productPurchaseDetailData['items'][i]
                        .delivery_date_str !==
                      data.data['items'][i].delivery_date_str
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].payment_date !==
                      data.data['items'][i].payment_date
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].unit_id !==
                      data.data['items'][i].unit_id
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].unit !==
                      data.data['items'][i].unit
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i]
                        .delivery_location !==
                      data.data['items'][i].delivery_location
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                    if (
                      productPurchaseDetailData['items'][i].memo !==
                      data.data['items'][i].memo
                    ) {
                      isDataUpdated = true;
                      break;
                    }
                  }
                }
              }

              if (isDataUpdated === false) {
                let oldData = Object.keys(productPurchaseDetailData);
                let updatedData = Object.keys(data.data);

                oldData = oldData.filter(
                  (char: any, aa: any) => char !== 'items'
                );
                updatedData = updatedData.filter(
                  (char: any, aa: any) => char !== 'items'
                );

                if (oldData.length !== updatedData.length) {
                  isDataUpdated = true;
                } else {
                  for (let el of updatedData) {
                    if (productPurchaseDetailData[el] !== data.data[el]) {
                      isDataUpdated = true;
                      break;
                    }
                  }
                }
              }

              if (isDataUpdated) {
                uploadProductPurchasePdf(
                  data.data,
                  newProductPurchaseId,
                  goPreview
                );
              } else {
                setShowLinearProgress(false);
                setOpenSuccess(true);
                if (goPreview === true) {
                  history.replace(
                    `/merchandise-orders/${newProductPurchaseId}/preview`,
                    {
                      rowId: history.location.state.rowId,
                      previouspath: history.location.state.previouspath,
                      params: history.location.state.params,
                      tabs: history.location.state.tabs,
                      constructId: history.location.state.state,
                      newProductPurchaseId: newProductPurchaseId
                    }
                  );
                }
              }
            }
            if (data.data.user_status === EMPLOYEE_STATUS.INACTIVE) {
              const createrData: StaffData = {
                name: data.data.on_site_supervisor,
                id: data.data.user_id
              };
              setInitialCreaterData(createrData);
            } else {
              setInitialCreaterData(null);
            }
            setProductPurchaseDetailData(data.data);
            setUserId(data.data.user_id);
            setVendorName(data.data.partner_id);
            setHonorificTitle(data.data.honorific_title);
            setDeliverySiteId(data.data.delivery_site_id);
            setOrderDate(data.data.order_date);
            setDocumentNumber(data.data.code);
            setConstructionName(data.data.construction_name);

            if (data.data.order_date !== '') {
              setSelectedOrderDate(new Date(data.data.order_date));
            }
            setOrderStatus(data.data.order_status);
            if (data.data.invoice_billing_total) {
              setInvoiceBillingTotal(data.data.invoice_billing_total); // 請求金額を格納
            }
            setDeliveryDate(data.data.delivery_date);
            if (data.data.delivery_date !== '') {
              setSelectedDeliveryDate(new Date(data.data.delivery_date));
            }
            if (data.data.payment_date !== '') {
              setSelectedPaymentDate(new Date(data.data.payment_date));
              setPaymentDate(data.data.payment_date);
            }
            if (data.data.sample1_user_id && data.data.sample1_user_id !== '') {
              setSampleUserId1(data.data.sample1_user_id);
            }
            if (data.data.billing_total) {
              setTotalAmount(data.data.billing_total);
            }
            if (data.data.sample2_user_id && data.data.sample2_user_id !== '') {
              setSampleUserId2(data.data.sample2_user_id);
            }
            setRemarks(data.data.remarks);
            setBillingNote(data.data.billing_note);
            setMemo(data.data.memo);
            let iIds: any = [];
            data.data.items.map((k: any, index: number) => {
              let iRowCount: any = rowCount;
              iRowCount[index] = 1;
              setRowCount(iRowCount);

              iIds.push(k.id);

              let iProductNameList: any = productNameList;
              iProductNameList[index] = k.name;
              setProductNameList(iProductNameList);

              let iSpecList: any = specificationList;
              iSpecList[index] = k.spec;
              setSpecificationList(iSpecList);

              let iUnitPriceList: any = unitPriceList;
              iUnitPriceList[index] = k.unit_price;
              setUnitPriceList(iUnitPriceList);

              let iQuantityList: any = quantityList;
              iQuantityList[index] = k.quantity;
              setQuantityList(iQuantityList);

              let iAmountList: any = amountList;
              iAmountList[index] = k.price;
              setAmountList(iAmountList);

              // 見積書から発注書に転記した「明細をもつ大項目」は数量・金額非表示flgをもつ
              let iHiddenList: any = hiddenList;
              iHiddenList[index] = k.hidden_flg;
              setHiddenList(iHiddenList);

              let iUnitList: any = unitList;
              iUnitList[index] = k.unit_id;
              setUnitList(iUnitList);

              let iDeliveryLocationList: any = deliveryLocationList;
              iDeliveryLocationList[index] = k.delivery_location;
              setDeliveryLocationList(iDeliveryLocationList);

              let iDeliveryDateList: any = deliveryDateList;
              iDeliveryDateList[index] = k.delivery_date;
              setDeliveryDateList(iDeliveryDateList);

              return <></>;
            });
            setItemIds(iIds);
            setLoading(false);
          }
        }
      }
    });
  };

  //upload pdf
  const uploadProductPurchasePdf = async (
    pdfData: any,
    newProductPurchaseId: number,
    goPreview: boolean
  ) => {
    let blob = await productPurchasePdf(pdfData);
    const formData: any = new FormData();
    formData.append(
      'document_type_id',
      JSON.stringify(DOCUMENT_TYPE.MERCHANDISE_ORDER)
    );
    formData.append('product_id', JSON.stringify(newProductPurchaseId));
    formData.append('file_obj', blob);

    savePdf(formData).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setShowLinearProgress(false);
            setOpenSuccess(true);
            if (goPreview === true) {
              history.push(
                `/merchandise-orders/${newProductPurchaseId}/preview`,
                {
                  rowId: history.location.state.rowId,
                  previouspath: history.location.state.previouspath,
                  params: history.location.state.params,
                  newProductPurchaseId: newProductPurchaseId,
                  tabs: history.location.state.tabs,
                  constructId: history.location.state.constructId
                }
              );
            }
          }
        }
      }
    });
  };

  const editMerchandiseDetails = (goPreview: boolean = false) => {
    if (userId === 0 || !userId) {
      setErrorMessage('作成者を選択してください。');
      setOpen(true);
    } else if (vendorName === 0 || !vendorName) {
      setErrorMessage('発注先業者名を選択してください。');
      setOpen(true);
    } else if (deliverySiteId === 0 || !deliverySiteId) {
      setErrorMessage('納品場所を選択してください。');
      setOpen(true);
    } else if (orderDate === '' || selectedOrderDate === null) {
      setErrorMessage(`発注日を入力してください。`);
      setOpen(true);
    } else if (orderStatus === 0 || !orderStatus) {
      setErrorMessage('ステータスを選択してください。');
      setOpen(true);
    } else if (deliveryDate === '' || selectedDeliveryDate === null) {
      setErrorMessage('納品日を入力してください。');
      setOpen(true);
    } else if (orderStatus === 2 && !invoiceBillingTotal) {
      // 請求金額が入力されておらず、差し戻しにしようとした際のエラー処理
      setErrorMessage(
        'ステータスを差戻しに変更する際は請求金額を入力してください。'
      );
      setOpen(true);
    } else {
      let l1 = productNameList.length;
      let l2 = unitPriceList.length;
      let l3 = quantityList.length;
      let l4 = amountList.length;
      // let l5 = unitList.length;
      // let l6 = deliveryDateList.length;
      // let l7 = deliveryLocationList.length;

      let flag = false;
      let flag1 = false;
      for (let index = 0; index < l1; index++) {
        if (deliveryDateList[index] === undefined) {
          flag1 = true;
        }
      }

      if (
        l1 === l2 &&
        l2 === l3 &&
        l3 === l4
        // &&
        // l4 === l5
        // &&
        // flag1 === false
      ) {
        flag = true;
      }

      // 更新可能フラグ
      let updateFlg = true;

      // 保存前のデータチェック用の配列
      let items: any = [];

      if (flag === true) {
        for (let i = 0; i < productNameList.length; i++) {
          let lenName = productNameList.length;
          let lenId = itemIds.length;
          let newArr1 = Array(lenName - lenId).fill(0);
          let concatArray1 = itemIds;
          let concatArray2 = concatArray1.concat(newArr1);
          setItemIds(concatArray2);

          items[i] = {
            id: concatArray2[i],
            name: productNameList[i],
            spec: specificationList[i],
            unit_price: unitPriceList[i],
            quantity: quantityList[i],
            price: amountList[i],
            unit: unitList[i],
            delivery_location: deliveryLocationList[i],
            delivery_date: deliveryDateList[i],
            hidden_flg: hiddenList[i]
          };
        }

        let arr: any = [];
        for (let n = 0; n < items.length; n++) {
          if (
            items[n].name &&
            typeof items[n].unit_price === 'number' &&
            !isNaN(items[n].unit_price) &&
            typeof items[n].quantity === 'number' &&
            !isNaN(items[n].quantity)
          ) {
            arr.push(items[n]);
          } else {
            if (
              typeof items[n].unit_price !== 'number' ||
              isNaN(items[n].unit_price)
            ) {
              setErrorMessage('正しい単価を入力してください。');
              setOpen(true);
              // ローダー非表示
              setShowLinearProgress(false);
              // 更新可能フラグをfalseに更新
              updateFlg = false;
              return;
            } else if (
              typeof items[n].quantity !== 'number' ||
              isNaN(items[n].quantity)
            ) {
              setErrorMessage('正しい数量を入力してください。');
              setOpen(true);
              // ローダー非表示
              setShowLinearProgress(false);
              // 更新可能フラグをfalseに更新
              updateFlg = false;
              return;
            } else {
              setErrorMessage('すべてのフィールドは必須です。');
              setOpen(true);
              // ローダー非表示
              setShowLinearProgress(false);
              // 更新可能フラグをfalseに更新
              updateFlg = false;
              return;
            }
          }
        }

        if (updateFlg) {
          updateFunction(arr, goPreview);
        }
      } else {
        setErrorMessage('必須フィールドに入力してください。');
        setOpen(true);
      }
    }
  };

  const updateFunction = (myNewArr: any, goPreview: boolean = false) => {
    updateMerchandiseOrder(
      params.id,
      userId,
      vendorName,
      honorificTitle,
      deliverySiteId,
      orderDate,
      orderStatus,
      deliveryDate,
      paymentDate,
      sampleUserId1,
      sampleUserId2,
      remarks.trim(),
      billingNote.trim(),
      memo.trim(),
      myNewArr,
      invoiceBillingTotal
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            // TODO: APIの仕様上請求金額の修正だけ別処理となっているがAPIの改修後こちらの部分要リファクタ
            updateMerchandiseOrderInvoiceTotal(
              params.id,
              invoiceBillingTotal ? invoiceBillingTotal : 0
            );
            setErrorMessage(data.message);
            getListOfUsers();
            getTheDetailsOfMerchandiseOrders(parseInt(params.id), goPreview);

            setShowLinearProgress(true);
          }
        }
      }
    });
  };

  useEffect(() => {
    getListOfUsers();
    getListOfVendors();
    getListOfDeliverySites();
    getTheDetailsOfMerchandiseOrders();
    getListOfMUnits();
  }, [
    // eslint-disable-line react-hooks/exhaustive-deps
    getListOfUsers,
    getListOfVendors,
    getListOfDeliverySites,
    getListOfMUnits
  ]);

  // 項目リストが更新された際の処理(行の追加と削除)
  useEffect(() => {
    setAddRowButton(true);
  }, [rowCount.length]);

  const getStatusFromId = (id: number) => {
    switch (id) {
      case 1:
        return <span>未着</span>;
      case 2:
        return <span>差戻し</span>;
      case 3:
        return <span>対応済み</span>;
      case 4:
        return <span>支払</span>;
      default:
        return <span></span>;
    }
  };

  const handleOpenSelectModal = () => {
    setopenSelectModal(true);
  };

  const handleCloseSelectModal = () => {
    setopenSelectModal(false);
    setVendorData(vendorDataSearch);
  };

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('xs');

  // パンくずリスト用に検索パラメーターを設定
  const patternState: TTopicPathState = {};
  patternState['/merchandise-orders'] = history.location.state;

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent
        patternName='merchandise_orders_edit'
        patternState={patternState}
      />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <div style={{ margin: 15 }}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Dialog
              open={openAlert}
              onClose={handleCloseAlert}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'削除しますか？'}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseAlert} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    handleCloseAlert();
                  }}
                  color='primary'
                  autoFocus
                >
                  削除
                </Button>
              </DialogActions>
            </Dialog>

            <VendorSearchDialog
              fullWidth={true}
              openSelectModal={openSelectModal}
              handleCloseSelectModal={handleCloseSelectModal}
              vendorData={vendorData}
              setVendorData={setVendorData}
              vendorDataSearch={vendorDataSearch}
              setVendorName={setVendorName}
            />

            <div className='table-top-container-customer'>
              <div style={{ fontWeight: 'bold' }}>
                <Button
                  style={{
                    minWidth: 90,
                    marginRight: 15,
                    color: '#758283',
                    backgroundColor: '#F5F5F5',
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => {
                    // 戻る先を判定する
                    if (
                      history.location.state.params ||
                      history.location.state.tabs
                    ) {
                      if (
                        history.location.state.previouspath ===
                        'to_construction'
                      ) {
                        // 工事一覧画面へ
                        history.replace(
                          `/constructions_document/${history.location.state.rowId}/edit`,
                          history.location.state
                        );
                        console.log(history.location.state);
                      } else {
                        //商品発注書一覧へ
                        history.push(
                          '/merchandise-orders',
                          history.location.state
                        );
                      }
                    } else {
                      if (history.location.state?.currentPage) {
                        history.push(
                          '/merchandise-orders',
                          history.location.state
                        );
                      } else {
                        history.goBack();
                      }
                    }
                  }}
                  startIcon={<ArrowBackIcon />}
                >
                  戻る
                </Button>
              </div>
            </div>

            {showLinearProgress && (
              <LinearProgress className={classes.progress} />
            )}

            <div style={{ backgroundColor: '#FFFFFF', paddingBottom: 40 }}>
              <div className='table-top-container-customer'>
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    fontSize: 24
                  }}
                >
                  {'商品発注書編集'}
                </div>
              </div>

              <Grid container>
                <Grid item xs={matches2 ? 4 : 12}>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        商品発注書番号
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.fixedTextContainer}>
                        {documentNumber}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>工事件名</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.fixedTextContainer}>
                        {constructionName}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        ステータス<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainerSelectBox}>
                        {userPermission === 1 || userPermission === null ? (
                          <select
                            value={orderStatus}
                            onChange={text => {
                              setOrderStatus(parseInt(text.target.value));
                            }}
                            className={classes.selectBoxStyle}
                            name='cars'
                            id='cars'
                            form='carform'
                          >
                            <option value={1}>未着</option>
                            <option value={2}>差戻し</option>
                            <option value={3}>対応済み</option>
                            <option value={4}>支払</option>
                          </select>
                        ) : (
                          getStatusFromId(orderStatus)
                        )}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        作成者<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainerSelectBox}>
                        <select
                          value={userId}
                          onChange={text => {
                            setUserId(parseInt(text.target.value));
                          }}
                          className={classes.selectBoxStyle}
                          name='cars'
                          id='cars'
                          form='carform'
                        >
                          <option value={0}>選択してください</option>
                          {getStaffSelectOptions(userData, initialCreaterData)}
                        </select>
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        発注先業者名<span>*</span>
                        <Button
                          style={{
                            padding: '2px 6px',
                            marginTop: 2,
                            color: '#758283',
                            backgroundColor: '#F5F5F5'
                          }}
                          variant='contained'
                          color='secondary'
                          startIcon={<SearchIcon />}
                          onClick={handleOpenSelectModal}
                        >
                          検索
                        </Button>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        className={classes.inputContainerSelectBox}
                        style={{ width: '70%' }}
                      >
                        <select
                          value={vendorName}
                          onChange={text => {
                            setVendorName(parseInt(text.target.value));
                            parseInt(text.target.value) !== 0 &&
                              calculationPaymentDate(
                                parseInt(text.target.value),
                                selectedDeliveryDate
                              );
                          }}
                          className={classes.selectBoxStyle}
                          name='cars'
                          id='cars'
                          form='carform'
                        >
                          <option value={0}>選択してください</option>
                          {vendorData.map((i: any) => (
                            <option value={i.id}>{i.name}</option>
                          ))}
                        </select>
                      </div>
                      <div
                        className={classes.inputContainer}
                        style={{ width: '30%', marginLeft: 0, paddingRight: 0 }}
                      >
                        <select
                          value={honorificTitle}
                          onChange={text => {
                            setHonorificTitle(text.target.value);
                          }}
                          className={classes.selectBoxStyle}
                        >
                          {/* <option value={0}>選択してください</option> */}
                          <option value='御中'>御中</option>
                          <option value='様'>様</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                </Grid>

                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        発注日<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          width: '100%'
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          id='order_date'
                          date={selectedOrderDate}
                          emptyLabel='日付を選択'
                          onChange={handleOrderDateChange}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        納品場所<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainerSelectBox}>
                        <select
                          value={deliverySiteId}
                          onChange={text => {
                            setDeliverySiteId(parseInt(text.target.value));
                          }}
                          className={classes.selectBoxStyle}
                          name='cars'
                          id='cars'
                          form='carform'
                        >
                          <option value={0}>選択してください</option>
                          {deliverySitesData.map((i: any) => (
                            <option value={i.id}>{i.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        納品日<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          width: '100%'
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          id='delivery_date'
                          date={selectedDeliveryDate}
                          emptyLabel='日付を選択'
                          onChange={handleDeliveryDateChange}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        合計金額（税抜）
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.textContainerPrice}>
                        {parsePrice(totalAmount, '')}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                </Grid>

                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>支払予定日</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          width: '100%'
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          id='payment_date'
                          date={selectedPaymentDate}
                          emptyLabel='日付を選択'
                          onChange={handleSelectedPaymentDate}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>備考</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <textarea
                          value={remarks}
                          placeholder='例) ※ご請求書はよく5日必着です。※締切り支払い[毎月末日・翌々15日支払い]'
                          onChange={text => {
                            setRemarks(text.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>メモ</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <textarea
                          value={memo}
                          onChange={text => {
                            setMemo(text.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        請求金額（税込）
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.textContainerPrice}>
                        <NumberInput
                          value={
                            invoiceBillingTotal
                              ? invoiceBillingTotal
                              : undefined
                          }
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setInvoiceBillingTotal(parseInt(e.target.value));
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                </Grid>
              </Grid>

              <div style={{ margin: 15, marginTop: 40 }}>
                <TableContainer component={Paper}>
                  <Table className={classes.main} aria-label='customized table'>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell className={classes.table} align='left'>
                          品名<span>*</span>
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          仕様
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          数量<span>*</span>
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          単位
                          <CustomTooltip
                            title={tooltipContents.itemUnit}
                            placement='right'
                          >
                            <HelpIcon
                              style={{ marginLeft: 8, marginBottom: 4 }}
                            />
                          </CustomTooltip>
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          単価<span>*</span>
                        </StyledTableCell>
                        <StyledTableCell className={classes.table} align='left'>
                          金額（税抜）<span>*</span>
                        </StyledTableCell>
                        <StyledTableCell
                          className={classes.table}
                          align='left'
                        ></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowCount.map((i: any, j: number) => (
                        <StyledTableRow>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //品名 */}
                            <input
                              value={productNameList[j]}
                              maxLength={38}
                              placeholder='38文字以内'
                              onChange={text => {
                                let newNameArr: any = [...productNameList];
                                newNameArr[j] = text.target.value;
                                setProductNameList(newNameArr);
                              }}
                              className={classes.inputBottom}
                            />
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //仕様 */}
                            <input
                              value={specificationList[j]}
                              maxLength={40}
                              placeholder='40文字以内'
                              onChange={text => {
                                let newNameArr: any = [...specificationList];
                                newNameArr[j] = text.target.value;
                                setSpecificationList(newNameArr);
                              }}
                              className={classes.inputBottom}
                            />
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 100 }}
                            align='left'
                          >
                            {/*  //数量 */}
                            {!hiddenList[j] ? (
                              <input
                                value={quantityList[j]}
                                type='number'
                                min='0'
                                max='99999'
                                onChange={text => {
                                  if (text.target.value.length > 8) {
                                    text.target.value = text.target.value.slice(
                                      0,
                                      8
                                    );
                                  } else {
                                    let newNameArr: any = [...quantityList];
                                    newNameArr[j] = parseFloat(
                                      text.target.value
                                    );
                                    setQuantityList(newNameArr);

                                    if (isNaN(parseFloat(text.target.value))) {
                                      let arr: any = [...amountList];
                                      arr[j] = 0;
                                      setAmountList(arr);

                                      let amount = 0;
                                      for (
                                        let ind = 0;
                                        ind < arr.length;
                                        ind++
                                      ) {
                                        amount += parseInt(arr[ind]);
                                      }
                                      setTotalAmount(amount);
                                    }

                                    if (
                                      isValidNumber(newNameArr[j]) &&
                                      isValidNumber(unitPriceList[j])
                                    ) {
                                      let arr: any = [...amountList];
                                      arr[j] = newNameArr[j] * unitPriceList[j];
                                      setAmountList(arr);

                                      let amount = 0;
                                      for (
                                        let ind = 0;
                                        ind < arr.length;
                                        ind++
                                      ) {
                                        amount += parseInt(arr[ind]);
                                      }
                                      setTotalAmount(amount);
                                    }
                                  }
                                }}
                                className={classes.inputBottom}
                                onWheel={(e: any) => e.target.blur()}
                              />
                            ) : (
                              <div style={{ display: 'none' }}>
                                {quantityList[j]}
                              </div>
                            )}
                          </StyledTableCell>

                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 140 }}
                            align='left'
                          >
                            {/*  //単位 */}
                            {!hiddenList[j] ? (
                              <select
                                value={unitList[j]}
                                onChange={text => {
                                  let newNameArr: any = [...unitList];
                                  newNameArr[j] = parseInt(text.target.value);
                                  setUnitList(newNameArr);
                                }}
                                className={classes.inputBottom}
                                style={{ height: 35 }}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {mUnitsData.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            ) : (
                              <div>{unitList[j]}</div>
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 100 }}
                            align='left'
                          >
                            {/*  //単価 */}
                            {!hiddenList[j] ? (
                              <NumberInput
                                maxLength={16}
                                symbol=''
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  let newNameArr: any = [...unitPriceList];
                                  newNameArr[j] = parseFloat(e.target.value);
                                  setUnitPriceList(newNameArr);

                                  if (isNaN(parseFloat(e.target.value))) {
                                    let arr: any = [...amountList];
                                    arr[j] = 0;
                                    setAmountList(arr);

                                    let amount = 0;
                                    for (let ind = 0; ind < arr.length; ind++) {
                                      amount += arr[ind];
                                    }
                                    setTotalAmount(amount);
                                  }

                                  if (
                                    isValidNumber(newNameArr[j]) &&
                                    isValidNumber(quantityList[j])
                                  ) {
                                    let arr: any = [...amountList];
                                    arr[j] = calcTotalFromQuantityAndUnitPrice(
                                      newNameArr[j],
                                      quantityList[j]
                                    );
                                    setAmountList(arr);

                                    let amount = 0;
                                    for (let ind = 0; ind < arr.length; ind++) {
                                      amount += arr[ind];
                                    }
                                    setTotalAmount(amount);
                                  }
                                }}
                                value={unitPriceList[j]}
                                className={classes.inputBottom}
                                dynamicCalculation={true}
                              />
                            ) : (
                              <div style={{ display: 'none' }}>
                                {unitPriceList[j]}
                              </div>
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 100 }}
                            align='right'
                          >
                            {/*  //金額 */}
                            <div style={{ fontSize: 16 }}>
                              {parsePrice(
                                isValidNumber(
                                  quantityList[j] * unitPriceList[j]
                                )
                                  ? calcTotalFromQuantityAndUnitPrice(
                                      quantityList[j],
                                      unitPriceList[j]
                                    )
                                  : '',
                                ''
                              )}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            align='right'
                          >
                            <Button
                              style={{
                                backgroundColor: buttonColor
                              }}
                              variant='contained'
                              color='primary'
                              onClick={() => {
                                const rowCountResult = rowCount.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setRowCount(rowCountResult);

                                const productNameListResult =
                                  productNameList.filter(
                                    (item: any, index: number) => index !== j
                                  );
                                setProductNameList(productNameListResult);

                                const specificationListResult =
                                  specificationList.filter(
                                    (item: any, index: number) => index !== j
                                  );
                                setSpecificationList(specificationListResult);

                                const quantityListResult = quantityList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setQuantityList(quantityListResult);

                                const unitListResult = unitList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setUnitList(unitListResult);

                                const unitPriceListResult =
                                  unitPriceList.filter(
                                    (item: any, index: number) => index !== j
                                  );
                                setUnitPriceList(unitPriceListResult);

                                const deliveryLocationListResult =
                                  deliveryLocationList.filter(
                                    (item: any, index: number) => index !== j
                                  );
                                setDeliveryLocationList(
                                  deliveryLocationListResult
                                );

                                const amountListResult = amountList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setAmountList(amountListResult);

                                const hiddenListResult = hiddenList.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setHiddenList(hiddenListResult);

                                const deliveryDateListResult =
                                  deliveryDateList.filter(
                                    (item: any, index: number) => index !== j
                                  );
                                setDeliveryDateList(deliveryDateListResult);

                                const itemIdsResult = itemIds.filter(
                                  (item: any, index: number) => index !== j
                                );
                                setItemIds(itemIdsResult);

                                let amount = 0;
                                for (
                                  let ind = 0;
                                  ind < quantityListResult.length;
                                  ind++
                                ) {
                                  amount += calcTotalFromQuantityAndUnitPrice(
                                    parseFloat(quantityListResult[ind]),
                                    parseFloat(unitPriceListResult[ind])
                                  );
                                }
                                setTotalAmount(amount);
                              }}
                            >
                              削除
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              {addRowButton && (
                <div style={{ position: 'absolute', right: 30 }}>
                  <CustomTooltip
                    title={tooltipContents.productPurchaseOrder}
                    placement='left'
                  >
                    <Button
                      style={{ backgroundColor: buttonColor }}
                      variant='contained'
                      color='secondary'
                      startIcon={<AddToPhotosIcon />}
                      onClick={() => setRowCount([...rowCount, 1])}
                    >
                      追加
                    </Button>
                  </CustomTooltip>
                </div>
              )}
              <div style={{ height: 10, backgroundColor: '#FFFFFF' }}></div>
            </div>
          </div>
          <div style={{ height: 80 }} />
          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              padding: 20
            }}
          >
            <div>
              <CustomTooltip title={tooltipContents.preview} placement='top'>
                <Button
                  style={{
                    marginRight: 15,
                    marginBottom: 0,
                    backgroundColor: buttonColor
                  }}
                  variant='contained'
                  color='primary'
                  disabled={showLinearProgress}
                  onClick={() => {
                    // TODO: 新規でも保存してプレビューさせる
                    editMerchandiseDetails(true);
                  }}
                >
                  プレビュー
                </Button>
              </CustomTooltip>
              <Button
                style={{
                  marginRight: 30,
                  marginBottom: 0,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
                disabled={showLinearProgress}
                onClick={() => {
                  editMerchandiseDetails();
                }}
              >
                保存
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
